import { LookupApi } from './../../../core/api.gen';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { concat, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, startWith, switchMap, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'eos-type-ahead-locations',
  template: `
  <ng-select [items]="options$ | async"
      [notFoundText]="to.notFoundText"
      [placeholder]="to.placeholder"
      [typeahead]="searchInput$"
      bindLabel="displayText"
      [loading]="showLoader"
      [formControl]="formControl">
      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      <div><span>{{item.displayText}}</span></div>
      
    </ng-template>
    </ng-select>
  `,
  styleUrls: ['./type-ahead-locations.component.css']
})

export class TypeAheadLocationsComponent extends FieldType implements OnDestroy {
  onDestroy$ = new Subject<void>();
  searchInput$ = new Subject<string>();
  options$;
  showLoader = false;

  constructor(private lookupService: LookupApi) {
    super();
  }

  ngOnInit() {
    this.options$ = concat(
      of([]),
      this.searchInput$.pipe(
        takeUntil(this.onDestroy$),
        startWith(''),
        filter(v => v !== null && v.length > 2),
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => this.showLoader = true),
        switchMap(term => this.lookupService.getAllOfficeLocationSearchable(term).pipe(
          catchError(() => of([])),
          tap(() => this.showLoader = false)
        ))
      )
    );
  }

  ngOnDestroy() {
    this.onDestroy$.complete();
  }
}

